
import { get, last } from 'lodash'
import { DropdownMenu, DropdownItem, Button, Toast, Empty } from 'vant'

import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  reactive,
  toRefs,
  toRaw,
  provide,
  nextTick
} from 'vue'
import { useRoute } from 'vue-router'
import { getBrushQuestionTextVersion, getBrushQuestionKnowledge } from '@/api/weeksStudy'
import ContentsItem from './component/ContentsItem'
import SearchItem from './component/SearchItem'
export default defineComponent({
  components: {
    ContentsItem,
    SearchItem,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Empty.name]: Empty
  },
  setup() {
    const isShowPage = ref(false)
    const route = useRoute()
    const gradeId = get(route, 'query.gradeId', '')
    const subjectId = get(route, 'query.subjectId', '')
    document.title = `${get(route, 'query.subjectName', '')}题库`
    provide('gradeId', gradeId)
    provide('subjectId', subjectId)
    onMounted(() => {
      document.body.style.backgroundColor = '#F6F6F6'
    })
    onUnmounted(() => {
      document.body.style.backgroundColor = '#fff'
    })
    // 为啥不早说弄成手风琴
    const contentsItems = ref(null)
    const handleContentsItemOpen = (id) => {
      console.log(id, contentsItems.value)
      contentsItems.value.map((item, i) => {
        item.activeNames = []
        // console.log(i, (item.activeNames = []))
      })
    }

    // 搜索
    const refDropdownItem = ref(null)
    const searchState = reactive({
      serachValues: [],
      searchLabels: [],
      searchArrOptions: [],
      submitSearchValues: [], // 最终的搜索value
      submitSearchLabels: []
    })
    provide('searchState', searchState)
    const handleSetSearchChild = (child, index) => {
      console.log(child, index)

      searchState.searchArrOptions[index + 1] = child
    }

    const getSearchDef = (data) => {
      let first = data[0]
      if (!first) return []
      console.log('first', first)
      let result = [{ id: first.id, name: first.name }]
      if (get(first, 'childList.options', []).length) {
        result = [...result, ...getSearchDef(get(first, 'childList.options', []))]
      }
      return result
    }

    //获取目录
    const knowledge = ref([])
    const getBrushQuestionKnowledgeFun = async (params) => {
      console.log(params)
      try {
        Toast.loading({
          message: '加载中...',
          forbidClick: true
        })
        let {
          data: { data }
        } = await getBrushQuestionKnowledge(params)
        console.log(data)
        knowledge.value = []

        nextTick(() => {
          knowledge.value = get(data, 'data', [])
        })

        Toast.clear()
      } catch (error) {
        Toast.fail('加载失败，请重新选择')
      }
    }
    onMounted(async () => {
      try {
        if (!gradeId || !subjectId) return
        //获取版本树
        let params = {
          subjectId
        }
        let {
          data: { data }
        } = await getBrushQuestionTextVersion(params)
        console.log(data)
        if (!Object.keys(data)) return
        searchState.searchArrOptions = [data]
        //获取版本树默认
        let searchDefaultOptins = toRaw(
          get(searchState.searchArrOptions, '[0].options', []).filter((item) => item.id == gradeId)
        )
        searchState.submitSearchValues = getSearchDef(searchDefaultOptins).map((item) => item.id)
        searchState.submitSearchLabels = getSearchDef(searchDefaultOptins).map((item) => item.name)
        getBrushQuestionKnowledgeFun({ csId: last(toRaw(searchState.submitSearchValues)) })
        isShowPage.value = true
      } catch (error) {
        console.log(error)
      }
    })

    // 关闭搜索
    const handleCloseSearch = () => {
      refDropdownItem.value.toggle()
    }
    //下来菜单打开
    const handleDropdownOpen = () => {
      searchState.serachValues = [...toRaw(searchState.submitSearchValues)]
    }
    //  提交搜索信息 获取列表
    const handleSubmitSearch = () => {
      searchState.submitSearchValues = [...toRaw(searchState.serachValues)]
      searchState.submitSearchLabels = [...toRaw(searchState.searchLabels)]
      refDropdownItem.value.toggle()
      getBrushQuestionKnowledgeFun({ csId: last(toRaw(searchState.submitSearchValues)) })
    }
    return {
      contentsItems,
      handleContentsItemOpen,
      subjectId,
      isShowPage,
      handleSetSearchChild,
      handleCloseSearch,
      handleSubmitSearch,
      handleDropdownOpen,
      ...toRefs(searchState),
      refDropdownItem,
      knowledge
    }
  }
})
